module.exports = __webpack_public_path__ + "static/media/trainingCourses.fa07ae45.svg";